import { useCallback, useMemo } from "react";
import { useUserState } from "@/hooks/userState/useUserState";

const DEFAULT_LAYOUT = { panelOrder: [] as string[] };

/** Keeps the saved order for known panels and appends panels added since it was saved. */
export function mergePanelOrder(saved: string[], defaults: string[]): string[] {
  const known = saved.filter(id => defaults.includes(id));
  const missing = defaults.filter(id => !known.includes(id));
  return [...known, ...missing];
}

export function useRowDetailLayout(defaultOrder: string[]) {
  const { value, setValue } = useUserState("rowDetail:panelOrder", DEFAULT_LAYOUT);

  const panelOrder = useMemo(
    () => mergePanelOrder(value.panelOrder, defaultOrder),
    [value.panelOrder, defaultOrder],
  );

  const savePanelOrder = useCallback((order: string[]) => setValue({ panelOrder: order }), [setValue]);

  return { panelOrder, savePanelOrder };
}
